export { Upload } from 'antd'
export type { UploadProps } from 'antd/lib/upload'
export type { UploadFile, UploadChangeParam } from 'antd/lib/upload/interface'
